/* eslint-disable */
import { useState, useEffect, useContext, useMemo } from "react";

// material react table
import { MaterialReactTable } from "material-react-table";
import { defaultTableConfig, withStrictFilter } from "Config/tableConfig";
import * as XLSX from "xlsx";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import context
import { GlobalProvider } from "context/GlobalContext";
import { Link } from "react-router-dom";


const MaterialKitList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const { t } = useTranslation(); //for translation
  const token = localStorage.getItem("token");

  const {
    reloadMaterialList,
    setReloadMaterialList,
    setEditMaterialData,
    screenHeight,
    showMaterialKitNameColumn,
    showMaterialKitSubjectColumn,
    showMaterialKitDate,
  } = useContext(GlobalProvider);

  // default user data ------------------------------------
  const [materialData, setMaterialData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [columnFilters, setColumnFilters] = useState([]);

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return materialData.filter((item) => selectedIds.includes(item._id));
  };

  /* Excel export */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : materialData;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Material Kit.xlsx");
  };

  /* custom name html */
  const nameHTML = ({ dataItem }) => {
    return (
      <div className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.name}</span>

          {/* ------ edit icon start ------ */}
          <Link
            to="#saveMaterialPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditMaterialData(dataItem);
              }}
            >
              edit
            </span>
          </Link>
          {/* ------ edit icon end ------ */}

          {/* -------------- calendar icon start ------------- */}
          <Link
            to={"/materialcalendar/" + dataItem._id}
            className="icon-btn edit_icon"
            role="button"
          >
            <span className="d-block material-symbols-outlined">
              calendar_month
            </span>
          </Link>
          {/* -------------- calendar icon end ------------- */}
        </div>
      </div>
    );
  };

  //function for get all data
  const getAllData = async (currentSearch = search) => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_MATERIAL_KIT + `?token=${token}`;

      if (currentSearch?.trim()) {
        requestUrl += `&globalsearch=${encodeURIComponent(currentSearch.trim())}`;
      }

      const response = await getData(requestUrl);

      console.log(`Material kit response`, response);
      if (response.status) {
        setMaterialData(response.data);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (reloadMaterialList) {
      getAllData();
      setReloadMaterialList(false);
    }
  }, [reloadMaterialList]);

  useEffect(() => {
    getAllData();
  }, [search]);

  /* hook to hit exportExcel() function */
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records when materialData changes */
  useEffect(() => {
    setRecords(materialData.length);
  }, [materialData]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, materialData]);

  /* Reset selection when material list changes (after delete/reload) */
  useEffect(() => {
    setRowSelection({});
  }, [materialData]);

  const tableColumns = useMemo(
    () => withStrictFilter((() => {
      const cols = [];

      if (showMaterialKitNameColumn) {
        cols.push({
          id: "name",
          accessorKey: "name",
          header: t("Name"),
          Cell: ({ row }) => nameHTML({ dataItem: row.original }),
          size: 200,
        });
      }
      if (showMaterialKitSubjectColumn) {
        cols.push({
          id: "unitsperday",
          accessorKey: "unitsperday",
          header: t("Unit Available Per Day"),
          size: 200,
        });
      }
      if (showMaterialKitDate) {
        cols.push({
          id: "materialkitdate",
          accessorKey: "materialkitdate",
          header: t("Date"),
          size: 200,
        });
      }

      return cols;
    })()),
    [
      showMaterialKitNameColumn,
      showMaterialKitSubjectColumn,
      showMaterialKitDate,
      materialData,
    ]
  );

  return (
    <div className="activity_table">
      {/* Hidden checkboxes so MaterialKitHeader deleteHandler can detect selected rows */}
      <div style={{ display: "none" }}>
        {materialData.map((material) => (
          <input
            key={material._id}
            type="checkbox"
            name="selectMaterialRecord"
            value={material._id}
            checked={!!rowSelection[material._id]}
            onChange={() => {}}
          />
        ))}
      </div>
      <div className="table-responsive">
        <MaterialReactTable
          {...defaultTableConfig}
          enableGlobalFilter
          globalFilterFn="strictContains"
          columns={tableColumns}
          data={materialData}
          enableSorting
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          onColumnFiltersChange={setColumnFilters}
          getRowId={(row) => row._id}
          state={{ rowSelection, columnFilters, isLoading }}
          renderLoadingOverlay={() => null}
          muiLinearProgressProps={{ sx: { display: "none" } }}
          muiCircularProgressProps={{ sx: { display: "none" } }}
          muiTableContainerProps={{ 
            sx: { 
              maxHeight: screenHeight,
              overflow: 'auto'
            } 
          }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
          muiTableHeadCellProps={{ 
            title: "",
            sx: {
              position: 'sticky',
              top: 0,
              zIndex: 1,
              backgroundColor: 'white'
            }
          }}
        />
      </div>
    </div>
  );
};

export default MaterialKitList;
